import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    moreOptions: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** aria-label for the more options button for folders in the project tree. */
            moreOptions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectTree_Folder.moreOptions?c=20ybj26k81yd3", defaultMessage: "More options" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
